import * as types from '../actions/actionTypes';

const initialState = {
  quotes: [
    {}
  ],
  activeQuoteIndex: 0,
};

export default function(state = initialState, action) {
  let updatedQuotes;
  switch(action.type) {
    case types.ADD_NEW_QUOTE:
    case types.SET_QUOTES:
    case types.SET_ACTIVE_QUOTE_INDEX:
      return Object.assign({}, state, {
        ...action.payload
      });
    case types.UPDATE_QUOTE:
      updatedQuotes = [...state.quotes];
      updatedQuotes[updatedQuotes.findIndex(item => item === action.payload.quote)] = action.payload.updatedQuote
      return Object.assign({}, state, {quotes: updatedQuotes});
  }

  return state;

}
